import React from "react";
import classNames from "classnames";
import { CURRENCY_TITLE } from "@app/constants/currencies";
import { Currency } from "@app/types/currencies";
import { useFormatDate } from "@app/hooks";

type Props = {
  payload: { date: string; rate: number };
  baseCurrency: Currency;
  convertCurrency: Currency;
};

export const CustomTooltip: React.FC<Props> = ({
  payload,
  baseCurrency,
  convertCurrency,
}) => {
  const date = useFormatDate(payload.date);

  return (
    <div
      className={classNames(
        "text-regular text-primary-content visible",
        "md:text-medium",
      )}
    >
      <div>{date}</div>
      <div>
        1 {CURRENCY_TITLE[baseCurrency]} ={" "}
        <span className={"text-green-light"}>{payload.rate.toFixed(5)}</span>{" "}
        {CURRENCY_TITLE[convertCurrency]}
      </div>
    </div>
  );
};
